import { css } from '@emotion/css';

const styles = {
  section: css`
    padding: 24px 16px 16px;
  `,
  dividerSpacing: css`
    padding: 0px 16px 0px 16px;
  `,
  container: css`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 40px;
  `,
  content: css`
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
  `,
  endMessage: css`
    display: flex;
    justify-content: center;
    margin-top: 100px;
    margin-bottom: 20px;
  `,
  seeMoreFlyersContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  seeMoreFlyersButton: css`
    text-transform: none !important;
  `,
  iconEmptyState: css`
    position: relative;
    top: 8px;
  `,
  link: css`
    text-decoration: underline;
  `,
  rowContainer: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
  `,
};

export default styles;
